export default __webpack_public_path__ + "static/media/Commander's Gauntlets of the Watchtowers.32064bc1.jpg";